import { Suspense } from 'react'
import ErrorBoundary from '@/components/error/ErrorBoundary'
import { LoadingProvider } from '@/contexts/LoadingContext'
import { CentralLoader } from '@/components/ui/CentralLoader'

import AppRoutes from './router/routes'
import { Toaster } from '@/components/ui/sonner'
import { AuthProvider } from '@/features/auth/hooks/useAuth'
import AuthTokenHandler from '@/features/auth/components/AuthTokenHandler'
import WhatsNewModal from '@/components/WhatsNewModal'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <LoadingProvider>
          <div className="min-h-screen bg-gray-50 font-inter">
            {/* Capture auth tokens from cookies/URL before routes render */}
            <AuthTokenHandler />
            {/* Central loader for all pages - controlled via LoadingContext */}
            <CentralLoader text="Loading" />
            <Suspense fallback={null}>
              <AppRoutes />
            </Suspense>
            <WhatsNewModal />
            <Toaster position="top-right" />
          </div>
        </LoadingProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
